import CcmCampaignPayments from './CcmCampaignPayments';

import ccmCampaignPayments from './redux/store';

export { ccmCampaignPayments };
export default CcmCampaignPayments;
